import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { IInfoHOCProps } from './types';
import { Info } from '../../components/Info/Info';
import { IInfoFields } from '../../components/Info/types';
import { getBoard } from '../../../../../../../../store/model/selectors/getBoardById';

const mapStateToProps = (
    state: IApplicationState,
    { boardId, isReadonly }: IInfoHOCProps
): IInfoFields => {
    return {
        boardId,
        isDescription: !!getBoard(state, boardId).description,
        isReadonly,
    };
};

export const InfoHOC = connect(
    mapStateToProps,
    null
)(Info);

InfoHOC.displayName = 'InfoHOC';
